import { Component } from "@angular/core"
import { AlertController, LoadingController, ModalController } from "ionic-angular"

import { AppUtils } from "../../services/app-utils"
import { EventService } from "../../services/event"
import { EventDetailPage } from "./detail"
import { EventReleasePage } from "./release"
import { EventExchangePage } from "./exchange"

@Component({
  selector: "events-page",
  templateUrl: "index.html",
})
export class EventsPage {

  viewOption = "next"
  nextEvents = []
  exchanges = []

  constructor(
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController
  ) {}

  ionViewDidEnter() {

    this.loadEvents()
  }

  loadEvents() {

    const loading = this.loadingCtrl.create({ content: "Obtendo eventos..." })

    loading.present()

    this.nextEvents = []

    EventService.getEvents("next")
      .then((months) => {

        months.forEach((month) => {

          month.events.forEach((event) => EventService.setEventStatus(event))
          this.nextEvents.push(month)
        })

        this.addMonthExchanges()

        loading.dismiss()
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao obter eventos",
          buttons: ["Ok"]
        }).present()
      })
  }

  addMonthExchanges() {

    this.exchanges = []

    this.nextEvents.forEach((month) => {

      let events = []
      let exchangeMonth = AppUtils.cloneObject(month)

      exchangeMonth.events.forEach((event) => {

        if (event.status == "released" || event.status == "exchange_requested")
          events.push(event)
      })

      if (events.length > 0) {
        exchangeMonth.events = events.slice()
        this.exchanges.push(exchangeMonth)
      }
    })
  }

  onEventClick(event) {

    const modal = this.modalCtrl.create(EventDetailPage, { eventId: event._id })

    modal.onDidDismiss((data) => {

      if (!data)
        return

      if (data.action == "confirmed") {

        const loading = this.loadingCtrl.create({ content: "Confirmando evento..." })

        loading.present()

        EventService.confirmEvent(event)
          .then(() => loading.dismiss())
          .catch((error) => {

            console.log(error)

            this.alertCtrl.create({
              message: "Falha ao confirmar evento",
              buttons: ["Ok"]
            }).present()
          })

      } else if (data.action == "released") {

        const modal = this.modalCtrl.create(EventReleasePage, { event })

        modal.onDidDismiss((data) => {

          if (data && data.released) {
            EventService.setEventStatus(event, data.event.status)
            this.addMonthExchanges()
          }
        })

        modal.present()

      } else if (data.action == "exchanged") {

        const modal = this.modalCtrl.create(EventExchangePage, { event })

        modal.onDidDismiss((data) => {

          if (data && data.exchangeRequested) {
            EventService.setEventStatus(event, data.event.status)
            this.addMonthExchanges()
          }
        })

        modal.present()

      } else if (data.action == "canceled") {

        EventService.setEventStatus(event, data.event.status)
        this.addMonthExchanges()
      }
    })

    modal.present()
  }
}



// WEBPACK FOOTER //
// ./src/pages/events/index.ts